import React from 'react';
import type { PropsWithChildren } from 'react';

import { ErrorBoundaryProvider } from '@reckon-web/error-boundary';

import { BookSetupWizardFeatureFlagProvider } from '../core/featureFlag/BookSetupWizardFeatureFlagProvider';

import { SiteRoutesProvider } from './Navigation';
import { AuthProvider, AuthenticatedUserProvider } from './Auth';
import { PlatformApolloProvider } from './Api';
import { PendoIdentity } from './Pendo/PendoIdentity';

/**
 * Wraps up all the various Service Providers
 *
 * If you need more global context, providers and hooks, then Providers get instantiated here
 */
export function ServicesProvider(props: PropsWithChildren<{}>) {
  return (
    <ErrorBoundaryProvider>
      <AuthProvider>
        <PlatformApolloProvider>
          <AuthenticatedUserProvider>
            <PendoIdentity />
            <BookSetupWizardFeatureFlagProvider>
              <SiteRoutesProvider>{props.children}</SiteRoutesProvider>
            </BookSetupWizardFeatureFlagProvider>
          </AuthenticatedUserProvider>
        </PlatformApolloProvider>
      </AuthProvider>
    </ErrorBoundaryProvider>
  );
}
